import { MutationTree } from 'vuex'

import invoicesMutations from './invoices/mutations'
import ordersMutations from './orders/mutations'
import orderPaymentsMutations from './orderPayments/mutations'
import { OrderingState } from './state'

const mutations: MutationTree<OrderingState> = {
  ...invoicesMutations,
  ...ordersMutations,
  ...orderPaymentsMutations
}

export default mutations
